module.exports = __webpack_public_path__ + "img/virma_logo.c8dd56ec.jpg";